import React from "react";
import { SketchPicker } from "react-color";
import onClickOutside from "react-onclickoutside";
import style from "./ColorPicker.module.scss";
import { connect } from "react-redux";
import {
  closeColorPickerAction,
  setColorAction
} from "../../redux/actions/colorpicker";
 
function ColorPicker(props) {
          ColorPicker.handleClickOutside = e => {
    if (e.target !== document.getElementById("color-btn")) {
      closeHandler(e.target);
    }  
  }; 

  const closeHandler = e => {
         props.closeColorPickerAction(); 
  };  

  const colorHandler = color => {
    props.setColorAction(color.hex);
  };

  return (
    <div className={style.PickerWrapper}>
      <SketchPicker
        width={"100%"}
        open={false}
        className={style.Picker}
        color={props.color}
        onChange={colorHandler}
        disableAlpha={true}
      />
    </div>
  );
}

const clickOutsideConfig = {
  handleClickOutside: function() {
    return ColorPicker.handleClickOutside;
  }
};

const mapStateToProps = state => {
  return {
    opened: state.colorpicker.opened,
    color: state.colorpicker.color
  };
};

const mapDispatchToProps = { closeColorPickerAction, setColorAction };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(onClickOutside(ColorPicker, clickOutsideConfig));
